import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import userManager from './userManager';


class EnsureLoggedIn extends React.Component {

    componentDidMount() {
        const user = this.props.oidc.user;

        if (user == null || user.expired) {
            this.handleSignInRedirect();
        }
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.silentRenew.error || nextProps.silentRenew.error
            || this.props.oidcUserActions.signOut || nextProps.oidcUserActions.signOut) {
            this.handleSignInRedirect();        
        }
    }

    handleSignInRedirect() {
        userManager.clearStaleState();
        localStorage.clear();
        userManager.signinRedirect({data:{redirectUrl:window.location.pathname}});
    }

    render() {
        const user = this.props.oidc.user;
        if (user != null && !user.expired) {
            return this.props.children;
        } else {
            return null;
        }
    }
}

EnsureLoggedIn.propTypes = {
    oidc: PropTypes.object.isRequired,
    silentRenew: PropTypes.object.isRequired,
    children: PropTypes.object,
    oidcUserActions: PropTypes.object
};

const mapStateToProps = (state) => {
    return {
        oidc: state.oidc,
        silentRenew: state.silentRenew,
        oidcUserActions: state.oidcUserActions
    };
};


export default connect(mapStateToProps)(EnsureLoggedIn);


// WEBPACK FOOTER //
// ./src/oidc/EnsureLoggedIn.js